export const PERFORMANCE_EXTRACTION_STATUS = {
  disconnected: 'disconnected',
  connected: 'connected',
  processing: 'processing',
  error: 'error',
  refreshing: 'refreshing',

  // FE only
  nullableResults: 'nullable_results',

  // deprecated
  created: 'created',
  running: 'running',
  done: 'done',
  doneWithErrors: 'done_with_errors',
  partialDone: 'partial_done',
} as const;
export type PerformanceExtractionStatus =
  (typeof PERFORMANCE_EXTRACTION_STATUS)[keyof typeof PERFORMANCE_EXTRACTION_STATUS];

export const VISIBLE_RESOURCES_STATUSES: PerformanceExtractionStatus[] = [
  PERFORMANCE_EXTRACTION_STATUS.connected,
  PERFORMANCE_EXTRACTION_STATUS.processing,
  PERFORMANCE_EXTRACTION_STATUS.refreshing,
];

export const isDisconnectedStatus = (status: PerformanceExtractionStatus): boolean =>
  status === PERFORMANCE_EXTRACTION_STATUS.disconnected;
